import React from 'react';
import { createPortal } from 'react-dom';
import { ProLightCircleArrowUp } from '@nexelem/icons/ProLightCircleArrowUp';
import { IconButton } from '@nexelem/components';

interface ScrollToTopButtonProps {
  showScrollToTop: boolean;
  handleScrollToTop: () => void;
  className?: string;
  portal?: {
    container: Element | DocumentFragment;
  };
}

export const ScrollToTopButton = ({
  showScrollToTop,
  handleScrollToTop,
  className = '',
  portal,
}: ScrollToTopButtonProps) => {
  if (!showScrollToTop) {
    return null;
  }

  const button = <IconButton className={className} Icon={ProLightCircleArrowUp} onClick={handleScrollToTop} />;

  if (portal) {
    return createPortal(button, portal.container);
  }

  return button;
};
